import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from '../../../core/helpers/strings.helper';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
	ActivateDeviceRequestModel,
	DeviceRegistrationOtpModel,
	DeviceRegistrationRequestModel,
} from '../../../shared/models/device.model';
import { DeviceService } from '../../../core/services/device.service';
import { StorageKeys } from '../../../shared/models/storage-keys';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { AuthenticationService } from '../../../core/services/authentication.service';

@Component({
	selector: 'app-device-otp',
	templateUrl: './device-otp.component.html',
	styleUrls: ['./device-otp.component.scss'],
})
export class DeviceOtpComponent implements OnInit {
	responseMessage: string;
	@Output() completedCallBack = new EventEmitter();
	@Output() cancelCallBack = new EventEmitter();
	@Output() errorCallBack = new EventEmitter();
	@Output() contractCode = new EventEmitter();
	@Output() deviceResponse = new EventEmitter();
	@Input() role: string;
	@Input() otpDesign: string;
	NEW_DESIGN = 'NEW';
	OLD_DESIGN = 'OLD';

	errorMessage: string;
	loadingButton: boolean;
	otpForm!: FormGroup;
	otpResponse: DeviceRegistrationOtpModel;
	currentStepIndex: number;
	loadingText = 'moniepoint.loading';
	timer: number;
	countDown: boolean;
	countDownTimer: number;
	deadline: number;
	deviceObj: { deviceUniqueIdentifier; manufacturer; model };
	loggedInUser: any;
	businessId: any;

	constructor(
		public deviceService: DeviceService,
		private fb: FormBuilder,
		private localstorage: LocalStorageService,
		private authService: AuthenticationService
	) { }

	ngOnInit(): void {
		try {
			if (!this.otpDesign) {
				this.otpDesign = this.OLD_DESIGN;
			}
			this.otpForm = this.fb.group({
				otp: [null, [Validators.required, this.otpValidation]],
			});
			this.deviceObj = this.deviceService.getDeviceObj();
			this.setDeviceObject(this.deviceObj);
			this.pageLoad();
		} catch (err) {
			console.log('Error from ngOnInit', err);
		}
		this.loggedInUser = this.localstorage.get(StorageKeys.username);
		this.businessId = this.localstorage.get(StorageKeys.businessId);
		this.businessId = this.businessId ? this.businessId : "01";
	}

	pageLoad() {
		this.currentStepIndex = 2;
		this.checkIfDeviceIsRegistered();
	}

	triggerOtpDeviceReg(retryTimer?: number, status?: number) {
		try {
			if (status) {
				this.timer = retryTimer;
				this.deadline = Date.now() + 1000 * 60 + 1000 * 1;
				this.setTimerValue();
			} else {
				this.deadline = Date.now() + 1000;
			}
			this.loadingButton = false;
			this.currentStepIndex = 0;
		} catch (error) {
			console.log('Error from triggerOtpDeviceReg  ', error);
		}
	}

	otpValidation(control: AbstractControl): { [key: string]: any } | null {
		const otp = control.value;
		const isValid = StringHelper.validOTP(otp);
		if (isValid) {
			return null;
		} else {
			return { otp: true };
		}
	}

	resendOtp() {
		this.triggerOtp(1);
	}

	setTimerValue() {
		this.countDown = true;
		// @ts-ignore
		this.countDownTimer = setInterval(() => {
			this.timer--;
			if (this.timer === 0) {
				this.countDown = false;
				clearInterval(this.countDownTimer);
				this.timer = 60;
			}
		}, 1000);
	}

	submitOtp() {
		const form = this.otpForm?.value;
		const otp = form?.otp;
		this.activateDeviceWithOtp(otp);
	}

	cancel() {
		this.cancelCallBack.emit(true);
	}

	buildActivateDeviceObj(otp: string) {
		const params = new ActivateDeviceRequestModel();
		params.deviceUniqueIdentifier = this.deviceObj.deviceUniqueIdentifier;
		params.otp = otp;
		params.activationToken = this.otpResponse.identifier || this.otpResponse?.tokenData?.phone;
		params.identifier = this.otpResponse.identifier || this.otpResponse?.tokenData?.phone;
		return params;
	}

	checkIfDeviceIsRegistered() {
		const username = this.localstorage.get(StorageKeys.username);
		const body = {
			uniqueIdentifier: this.deviceObj.deviceUniqueIdentifier,
			username,
		};
		this.deviceService
			.checkIfDeviceIsRegisteredPostRequest(body)
			.then((res) => {
				if (res?.registered) {
					this.setAlreadyRegisteredDevice();
				} else {
					this.triggerOtp(0);
				}
			})
			.catch((err) => {
				this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err) || 'Something went wrong';
				this.responseMessage = err?.errors?.responseMessage || 'Error Ocurred';
				this.setErrorCallBack(this.errorMessage);
				this.currentStepIndex = 5;
			});
	}

	setErrorCallBack(error: string) {
		this.errorCallBack.emit(error);
	}

	setAlreadyRegisteredDevice() {
		if (this.authService.getContextUser() === 'agents') {
			this.getUserDevice();
		} else {
			this.completedCallBack.emit(true);
			this.loadingButton = false;
		}
	}

	activateDeviceWithOtp(otp) {
		this.errorMessage = null;
		this.loadingButton = true;
		const params = this.buildActivateDeviceObj(otp);
		this.deviceService
			.activateDevice(params)
			.then((res) => {
				this.setAlreadyRegisteredDevice();
			})
			.catch((err) => {
				this.loadingButton = false;
				if (err.status === 200) {
					this.setAlreadyRegisteredDevice();
				} else {
					this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
				}
				this.loadingButton = false;
			});
	}

	triggerOtp(status?) {
		this.errorMessage = null;
		this.loadingButton = true;
		const params = this.buildDeviceRegistrationParams();
		this.deviceService
			.registerDeviceWithOtp(params, this.role)
			.then((res) => {
				this.otpResponse = res;
				this.setAlreadyRegisteredDevice();
				// this.triggerOtpDeviceReg(0);
			}).catch((error) => {
				if (error.error?.code === '403003') {
					this.otpResponse = error.error;
					const timer = this.otpResponse.retryTimer || 60;
					this.triggerOtpDeviceReg(timer, 1);
				} else {
					if (error.error?.code === '400208') {
						this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
						this.currentStepIndex = 5;
					} else if (status) {
						this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
					} else {
						this.setErrorCallBack(StringHelper.getErrorMessageHttpErrorResponse(error));
					}
				}
				this.loadingButton = false;
			});
	}

	buildDeviceRegistrationParams() {
		return new DeviceRegistrationRequestModel(this.deviceObj);
	}

	getUserDevice() {
		const contractCode = this.localstorage.get(`cc_${this.loggedInUser}_${this.businessId}`);
		if (contractCode) {
			this.fulfillContractCallEvent(contractCode);
			return;
		}
		const params = this.buildDeviceRegistrationParams();
		this.deviceService
			.registerDeviceWithOtp(params, 'agent')
			.then((data) => {
				this.localstorage.save(`cc_${this.loggedInUser}_${this.businessId}`, data?.profile?.contractCode);
				this.fulfillContractCallEvent(data.profile?.contractCode);
			})
			.catch((error) => {
				this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
				this.loadingButton = false;
			});
	}

	private fulfillContractCallEvent(contractCode: any) {
		this.setContractCode(contractCode);
		this.completedCallBack.emit(true);
		this.loadingButton = false;
	}

	private setContractCode(contractCode: any) {
		this.contractCode.emit(contractCode);
	}

	private setDeviceObject(deviceObj: { deviceUniqueIdentifier; manufacturer; model }) {
		this.deviceResponse.emit(deviceObj);
	}
}
